<template>
  <casino-form
    mode="create"
    @submit="handleSubmit"
  />
</template>

<script>
  import { CasinoForm } from '../../components'
  import { useCreateCasino } from './casinoHooks'

  export default {
    name: 'AddCasino',
    components: { CasinoForm },
    mixins: [
      useCreateCasino('handleSubmit'),
    ],
  }
</script>

<style scoped>

</style>
